import React from 'react';
import FeatureCards from "../../components/FeatureCards/FeatureCards";
import CTA from "../../components/Constant/cta/CTA";
import TimelineSection from "../../components/TimelineSection/TimelineSection";
import WhySection from "../../components/WhySection/WhySection";
import LocationTimeline from "../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../components/IntroSection/IntroSection";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../components/ServiceCards/ServiceCards ";

export default function SingaporeJurisdiction() {

    return (
        <main className='main'>
            <IntroSection
                title="Singapore Jurisdiction"
                subtitle="Company Formation, Financial Licensing & Residency in Singapore"
                description="Singapore is one of the world’s most reputable business hubs, consistently ranked as a Tier-1 financial center. With its low corporate tax (17%), strong double taxation treaty network, and world-class regulation, Singapore attracts multinational corporations, fintech innovators, and investment funds."
                badges={[
                    "Global Banking Hub",
                    "FinTech & Asset Management",
                    "Reputable Corporate Structures"
                ]}
                buttonText="Request a Singapore Jurisdiction Proposal →"
                buttonLink="/quote"
                imageSrc={require('../../assets/images/jurisdictions/singapore-jurisdiction.png')}
                imageAlt="Singapore Company Formation & Financial Licensing"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Singapore?'
                        blocks={[
                            {
                                items: [
                                    {
                                        title: "Reputation",
                                        text: "Highly respected worldwide, not seen as a 'tax haven.'"
                                    },
                                    {
                                        title: "Strategic Location",
                                        text: "Gateway to Asia-Pacific."
                                    },
                                    {
                                        title: "Corporate Tax Rate",
                                        text: "17%, with tax exemptions for startups and partial exemptions for SMEs."
                                    },
                                    {
                                        title: "Double Tax Treaties",
                                        text: "80+ treaties with major economies."
                                    },
                                    {
                                        title: "Regulation",
                                        text: "MAS is one of the world’s most credible regulators."
                                    },
                                    {
                                        title: "Ease of Business",
                                        text: "Fast incorporation and pro-business environment."
                                    }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Company Formation in Singapore"
                        blocks={[
                            {
                                title: "Private Limited Company (Pte Ltd)",
                                items: [
                                    { text: "Most common entity." },
                                    { text: "1 shareholder, 1 resident director required." },
                                    { text: "Eligible for tax incentives and exemptions." }
                                ]
                            },
                            {
                                title: "Variable Capital Company (VCC)",
                                items: [
                                    { text: "Designed for funds and asset managers." },
                                    { text: "Flexible umbrella structure." },
                                    { text: "Attracts private equity, hedge funds, and family offices." }
                                ]
                            },
                            {
                                title: "Branch or Representative Office",
                                items: [
                                    { text: "Suitable for foreign companies expanding into Singapore." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Licenses Available in Singapore"
                        blocks={[
                            {
                                title: "🏦 Banking License",
                                items: [{ text: "Full banks, wholesale banks, offshore banks." }]
                            },
                            {
                                title: "📈 Fund & Asset Management",
                                items: [{ text: "Capital Markets Services (CMS) License, VCC structures." }]
                            },
                            {
                                title: "💳 Payment Services Act (PSA) Licenses",
                                items: [{ text: "Major Payment Institution (MPI), Standard Payment Institution (SPI)." }]
                            },
                            {
                                title: "🪙 Digital Asset & Crypto Licenses",
                                items: [{ text: "Regulated under PSA, covers exchanges, wallets, custody." }]
                            },
                            {
                                title: "🛡️ Insurance & Reinsurance Licenses",
                                items: [{ text: "Regulated by MAS." }]
                            }
                        ]}
                    />

                    <LocationTimeline
                        title="Residency & Immigration in Singapore"
                        item={[
                            {
                                title: "EntrePass",
                                text: "For entrepreneurs and startups."
                            },
                            {
                                title: "Employment Pass (EP)",
                                text: "For professionals."
                            },
                            {
                                title: "Permanent Residency (PR)",
                                text: "Available after several years."
                            },
                            {
                                title: "Global Investor Program (GIP)",
                                text: "PR through investment."
                            }
                        ]}
                    />

                    <ServiceCards
                        title='Advantages of Singapore Jurisdiction'
                        services={[
                            {
                                title: "🌍 Tier-1 Credibility",
                                text: "Trusted worldwide."
                            },
                            {
                                title: "💼 Asia-Pacific Gateway",
                                text: "Ideal HQ for regional expansion."
                            },
                            {
                                title: "⚖️ Strong Legal System",
                                text: "English-based law, stable governance."
                            },
                            {
                                title: "🚀 FinTech-Friendly",
                                text: "MAS sandbox and clear regulations."
                            },
                            {
                                title: "📊 Investor Protection",
                                text: "Strong compliance and regulatory oversight."
                            }
                        ]}
                    />


                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <CTA
                        title="Ready to expand into Singapore?"
                        description="Offshore Advisory provides end-to-end company formation, financial licensing, and residency support in Singapore."
                        buttonText="Book a Free Consultation for Singapore Today →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "How fast can I register a Singapore company?",
        answer: "Usually 1–3 business days once requirements are met."
    },
    {
        question: "Do I need a local director?",
        answer: "Yes, at least one Singapore-resident director is required."
    },
    {
        question: "Is Singapore tax-free?",
        answer: "No, but tax rates are low (17%), with generous exemptions and incentives."
    },
    {
        question: "Can I open a crypto company in Singapore?",
        answer: "Yes, under the Payment Services Act, but subject to MAS approval."
    },
    {
        question: "Can I get residency by company formation?",
        answer: "Yes, with EntrePass or Employment Pass linked to your company."
    }
];

